import { create } from 'zustand';
import { persist } from 'zustand/middleware';

const useMyAppStore = create(
  persist(
    (set, get) => ({
      // État
      currentSale: null,
      isLoading: false,
      error: null,
      lastSync: null,
      pageTitle: 'Tableau de bord',
      theme: 'light',
      currentActivity: null,
      activitySettings: null, // Paramètres d'activité
      selectedLayout: 'retail',
      currentUser: null,

      // Actions
      setCurrentSale: (sale) => set({ currentSale: sale }),
      setLoading: (isLoading) => set({ isLoading }),
      setError: (error) => set({ error }),
      setLastSync: (timestamp) => set({ lastSync: timestamp }),
      setPageTitle: (title) => set({ pageTitle: title }),
      resetPageTitle: () => set({ pageTitle: 'Tableau de bord' }),
      toggleTheme: () => set((state) => ({ theme: state.theme === 'light' ? 'dark' : 'light' })),
      
      // Actions de gestion d'utilisateur
      setCurrentUser: (user) => {
        set({ currentUser: user });
        console.log('👤 Utilisateur mis à jour dans le store:', user);
      },
      clearCurrentUser: () => {
        set({ currentUser: null });
        console.log('👤 Utilisateur supprimé du store');
      },
      
      // Actions de gestion d'activité
      setCurrentActivity: (activity) => {
        set({ currentActivity: activity });
        // console.log('🔄 Activité mise à jour dans le store:', activity);
      },
      resetActivity: () => set({ currentActivity: null }),

      // Actions de gestion des paramètres d'activité
      setActivitySettings: (settings) => {
        set({ activitySettings: settings });
        console.log('⚙️ Paramètres d\'activité mis à jour dans le store:', settings);
      },
      updateActivitySettings: (updates) => {
        set((state) => ({
          activitySettings: state.activitySettings ? { ...state.activitySettings, ...updates } : updates
        }));
        console.log('⚙️ Paramètres d\'activité partiellement mis à jour:', updates);
      },
      resetActivitySettings: () => set({ activitySettings: null }),

      // Actions de gestion du layout
      setSelectedLayout: (layout) => {
        set({ selectedLayout: layout });
        console.log('🎨 Layout changé dans le store:', layout);
      },

      clearCurrentSale: () => set({ currentSale: null }),

      // Synchronisation
      syncWithCloud: async () => {
        set({ isLoading: true, error: null });
        try {
          // TODO: Implémenter la synchronisation avec le cloud
          set({ lastSync: new Date().toISOString() });
        } catch (error) {
          set({ error: error.message });
        } finally {
          set({ isLoading: false });
        }
      },

      // Réinitialisation complète du store
      resetAll: () => set({
        currentSale: null,
        isLoading: false,
        error: null,
        lastSync: null,
        pageTitle: 'Tableau de bord',
        theme: 'light',
        currentActivity: null,
        activitySettings: null,
        selectedLayout: 'retail',
        currentUser: null,
      }),
    }),
    {
      name: 'myapp-storage',
      partialize: (state) => ({
        lastSync: state.lastSync,
        pageTitle: state.pageTitle,
        theme: state.theme,
        currentActivity: state.currentActivity,
        activitySettings: state.activitySettings,
        selectedLayout: state.selectedLayout,
        currentUser: state.currentUser,
      }),
    }
  )
);

export default useMyAppStore; 